import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/httpJobs'

// Tests
export const testsList = (params = {}) => Http.get(`/personality-tests${serialize(params)}`)
export const testShow = (id) => Http.get(`/personality-tests/${id}`)
export const testCreate = (params = {}) => Http.post('/personality-tests', params)
export const testUpdate = (params = {}) => Http.put(`/personality-tests/${params.id}`, params)
export const testDestroy = (params = {}) => Http.delete(`/personality-tests/${params.id}`)

// Questions
export const questionsList = (slug = '') => Http.get(`/personality-tests/${slug}/questions`)
export const questionCreate = (slug = '', params = {}) => Http.post(`/personality-tests/${slug}/questions`, params)
export const questionUpdate = (params = {}) => Http.put(`/personality-tests/questions/${params.id}`, params)
export const questionDestroy = (params = {}) => Http.delete(`/personality-tests/questions/${params.id}`)

// Options
export const optionCreate = (questionId = '', params = {}) => Http.post(`/personality-tests/questions/${questionId}/options`, params)
export const optionUpdate = (params = {}) => Http.put(`/personality-tests/options/${params.id}`, params)
export const optionDestroy = (params = {}) => Http.delete(`/personality-tests/options/${params.id}`)

// Dimensions
export const dimensionsList = (slug = '') => Http.get(`/personality-tests/${slug}/dimensions`)
export const dimensionCreate = (slug = '', params = {}) => Http.post(`/personality-tests/${slug}/dimensions`, params)

// Interpretations
export const interpretationsList = (slug = '') => Http.get(`/personality-tests/${slug}/interpretations`)
export const interpretationCreate = (slug = '', params = {}) => Http.post(`/personality-tests/${slug}/interpretations`, params)
export const interpretationUpdate = (params = {}) => Http.put(`/personality-tests/interpretations/${params.id}`, params)
export const interpretationDestroy = (params = {}) => Http.delete(`/personality-tests/interpretations/${params.id}`)

// Monitoring
export const sessionsList = (params = {}) => Http.get(`/personality-tests/sessions${serialize(params)}`)
export const resultsList = (params = {}) => Http.get(`/personality-tests/results${serialize(params)}`)
export const regeneratePdf = (params = {}) => Http.post('/personality-tests/results/regenerate-pdf', params)
export const regeneratePdfBulk = (params = {}) => Http.post('/personality-tests/results/regenerate-pdf-bulk', params)

// Nurture leads
export const nurtureLeadsList = (params = {}) => Http.get(`/personality-tests/nurture-leads${serialize(params)}`)
